import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";
// @material-ui/icons
import Email from "@material-ui/icons/Email";
import People from "@material-ui/icons/People";
import LockOutlined from "@material-ui/icons/LockOutlined";
// React icons
import {FaLinkedinIn, FaTwitter, FaGooglePlusG } from 'react-icons/fa';
// core components
import Header from "components/Header/Header.jsx";
import HeaderLinks from "components/Header/HeaderLinks.jsx";
import Footer from "components/Footer/Footer.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import cushman from "assets/img/cushman.png";
import calogo from "assets/img/calogo.jpg";
import ContactForm from "components/ContactForm/ContactForm.js"
import loginPageStyle from "assets/jss/material-kit-react/views/loginPage.jsx";

import image from "assets/img/overheadheader.png";

class LoginPage extends React.Component {
  constructor(props) {
    super(props);
    // we use this to make the card to appear after the page has been rendered
    this.state = {
      cardAnimaton: "cardHidden"
    };
  }
  componentDidMount() {
    // we add a hidden class to the card and after 700 ms we delete it and the transition appears
    setTimeout(
      function() {
        this.setState({ cardAnimaton: "" });
      }.bind(this),
      700
    );
  }
  render() {
    const { classes, ...rest } = this.props;
    return (
      <div>
        <Header
          absolute
          color="transparent"
          brand="Material Kit React"
          rightLinks={<HeaderLinks />}
          {...rest}
        />
        <div
          className={classes.pageHeader}
          style={{
            backgroundImage: "url(" + image + ")",
            backgroundSize: "cover",
            backgroundPosition: "top center"
          }}
        >
          <div className={classes.container}>
            <GridContainer justify="center">
              <GridItem xs={12} sm={10} md={7}>
                <Card className={classes[this.state.cardAnimaton]}>
                  <div className={classes.form}>
                    <CardHeader color="primary" className={classes.cardHeader}>
                      <h4>CONTACT US</h4>
                      <div className={classes.socialLine}>
                        <Button
                          justIcon
                          href="#"
                          target="_blank"
                          color="transparent"
                          onClick={e => e.preventDefault()}
                        >
                          <FaTwitter/>
                        </Button>
                        <Button
                          justIcon
                          href="#"
                          target="_blank"
                          color="transparent"
                          onClick={e => e.preventDefault()}
                        >
                          <FaLinkedinIn/>
                        </Button>
                        <Button
                          justIcon
                          href="#"
                          target="_blank"
                          color="transparent"
                          onClick={e => e.preventDefault()}
                        >
                          <FaGooglePlusG/>
                        </Button>
                      </div>
                     
                    </CardHeader> 
                    
                    <GridContainer justify="center">
                    <GridItem xs={12} sm={6} md={6}>
                    <GridContainer justify="center">
                      <GridItem xs={12} sm={12} md={12}>
                      <div className={classes.agentwrap}>
                        <div className={classes.contactname}>Ben Bolton</div>
                        <div><a href="tel:+442920346376">029 20 34 6376</a> </div>
                        <div> <a href="tel:+447899923978">078 9992 3978</a> </div>
                        <div><a href="mailto:ben.bolton@coark.com">ben.bolton@coark.com</a></div>
                      <div className={classes.imagewrap}>
          <img alt="..." src={calogo} className={classes.contactlogo} />
          </div>
                      </div>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={12}>
                        <div className={classes.agentwrap}>
                        <div className={classes.contactname}>Chris Yates</div>
                        <div><a href="tel:+442920262272">029 20 26 2272</a></div>
                        <div> <a href="tel:+447850658050">078 50 65 8050</a></div>
                        <div><a href="mailto:chris.yates@coark.com">chris.yates@cushwake.com</a></div>
                        <div className={classes.imagewrap}>
          <img alt="..." src={cushman} className={classes.contactlogo} />
          </div>
                        </div>
                      </GridItem>
                    </GridContainer>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={6}>
                      <div className={classes.mright}>
                        <p className={classes.divider}>Please get in touch with your enquiry and we will respond as soon as possible.</p>
                        <ContactForm/>
                    
                    
                    {/* <CardBody>
                      <CustomInput
                        labelText="Name..."
                        id="name"
                        name="name"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          id: "name",
                          name: "name",
                          type: "text",
                          endAdornment: (
                            <InputAdornment position="end">
                              <People className={classes.inputIconsColor} />
                            </InputAdornment>
                          )
                        }}
                      />
                      <CustomInput
                        labelText="Email..."
                        id="email"
                        type="email"
                        name="email"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          id: "email",
                          name: "email",
                          type: "email",
                          endAdornment: (
                            <InputAdornment position="end">
                              <Email className={classes.inputIconsColor} />
                            </InputAdornment>
                          )
                        }}
                      />
                      <CustomInput
                        labelText="message"
                        id="message"
                        name="message"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          id: "message",
                          name: "message",
                          type: "text",
                        }}
                      />
                    </CardBody>
                    <CardFooter className={classes.cardFooter}>
                      <Button type="submit" simple color="primary" size="lg">
                        SUBMIT
                      </Button>
                    </CardFooter> */}
                    
                    </div>
                    </GridItem>
                    </GridContainer>
                  </div>
                </Card>
              </GridItem>
            </GridContainer>
          </div>
          <Footer whiteFont />
        </div>
      </div>
    );
  }
}

export default withStyles(loginPageStyle)(LoginPage);
